import React, { createContext, useEffect, useState } from 'react';
import { documentsService } from 'commons/services';
import { DocumentsInterface } from 'commons/types';

interface DocumentsContextInterface {
  dnis: DocumentsInterface;
  statute: string;
  powerOfAttorney: string;
  loading: boolean;
}

export const DocumentsContext = createContext({} as DocumentsContextInterface);

interface InterfaceDocumentsProvider {
  children: React.ReactNode;
}

function DocumentsProvider({
  children,
}: InterfaceDocumentsProvider): JSX.Element {
  const [documents, setDocuments] = useState({
    dnis: {},
    statute: '',
    powerOfAttorney: '',
    loading: true,
  });

  useEffect(() => {
    const fetchDocuments = async () => {
      const response = await documentsService.getDocuments();
      if (response) {
        const companyComposition = response.companyComposition
          ? response.companyComposition
          : '';
        const powerOfAttorney = response.powerOfAttorney
          ? response.powerOfAttorney
          : '';
        // @ts-expect-error ignore delete
        delete response.companyComposition;
        // @ts-expect-error ignore delete
        delete response.powerOfAttorney;
        setDocuments({
          dnis: response,
          statute: companyComposition,
          powerOfAttorney,
          loading: false,
        });
      } else {
        setDocuments((state) => ({ ...state, loading: false }));
      }
    };
    fetchDocuments();
  }, []);

  return (
    <DocumentsContext.Provider value={documents}>
      {children}
    </DocumentsContext.Provider>
  );
}

export default DocumentsProvider;
